import React, { Component } from 'react';

import { Avatar, Button, Card, Chip, DataTable, DialogContainer, Grid, 
    TableBody, TableColumn, TableRow, TableHeader } from 'react-md';

import Api from '../../common/api';
import { firstChar, formatCpf } from '../../common/formaters';

import Message from '../../components/message';
import Breadcrumb from '../../components/Breadcrumb';
import { openSnackbar } from '../../components/message';

import { Usuario } from '../../models/Usuario';
// import Filter from '../../components/Filter';
import UsuarioForm from '../../forms/UsuarioForm';

const COLORS = Avatar.defaultProps.suffixes;

export default class Usuarios extends Component {

    constructor(props) {
        super(props);

        this.state = {
            usuarios: [],
            visibleConfirm: false,
            visibleForm: false,
            pageX: null, 
            pageY: null,
            selectedUsuario: new Usuario(),
            filter: ""
        };
    }

    componentDidMount() {
        this.getAll();
    }

    render() {
        const { selectedUsuario, usuarios, visibleForm, pageX, pageY, visibleConfirm } = this.state;
        const confirmActions = [];
        confirmActions.push({ secondary: true, children: 'Cancelar', onClick: this.hideConfirm });
        confirmActions.push(<Button flat primary onClick={this.deleteUsuario}>Sim</Button>);

        return (
            <Grid>
                <Breadcrumb title="Usuários" url="/usuarios"/>
                <Card tableCard className="md-cell md-cell--12 tw-card">
                    <div className="buttons__group">
                        <div className="left-group">
                            <Button type="button" raised primary iconChildren="add" onClick={this.handleNewClick} 
                                aria-controls="modal-form">
                                Novo
                            </Button>
                        </div>
                        <div className="right-group">
                            <Button type="button" raised iconChildren="edit" onClick={this.handleEditCLick} 
                                disabled={this.hasSelected()} className="btn btn-secondary" aria-controls="modal-form"> 
                                Editar
                            </Button>
                            <Button type="button" raised primary iconChildren="delete" onClick={this.handleDeleteCLick} 
                                disabled={this.hasSelected()} className="btn btn-danger" >
                                Excluir
                            </Button>
                        </div>
                    </div>
                    
                    {/* <Filter onSearch={this.handleChangeFilter} placeholder="Pesquise por código ou descrição"/> */}

                    <DataTable baseId="usuarios-list" className="tw-table" plain={true} responsive>
                        <TableHeader>
                            <TableRow>
                                <TableColumn>Código</TableColumn>
                                <TableColumn>Nome</TableColumn>
                                <TableColumn>CPF</TableColumn>
                                <TableColumn>Email</TableColumn>
                                <TableColumn>Situação</TableColumn>
                            </TableRow>
                        </TableHeader>
                        <TableBody>
                        { usuarios.map((usuario, index) => (
                            <TableRow key={index} onClick={this.handleUsuarioClick(usuario)} aria-controls="modal-form" 
                                className={this.renderSelectedClass(usuario)}>
                                <TableColumn>{ usuario.id }</TableColumn>
                                <TableColumn className="column--avatar">
                                    <Avatar suffix={COLORS[index]}>{firstChar(usuario.nome)}</Avatar>
                                    { usuario.nome }
                                </TableColumn>
                                <TableColumn>{ formatCpf(usuario.cpf) }</TableColumn>
                                <TableColumn>{ usuario.email }</TableColumn>
                                <TableColumn>
                                    { usuario.ativo 
                                        ? <Chip label="Ativo" className="tw-chip-enabled" labelClassName="tw-chip-enabled" /> 
                                        : <Chip label="Inativo" className="tw-chip-disabled" labelClassName="tw-chip-disabled"/> 
                                    }
                                </TableColumn>
                            </TableRow>
                        ))}
                        </TableBody>
                    </DataTable>
                </Card>

                <UsuarioForm model={selectedUsuario} pageX={pageX} pageY={pageY} onSave={this.saveForm}
                    visible={visibleForm} onHide={this.hideForm} onChange={this.handleChangeUsuario}/>

                <DialogContainer id="confirm-dialog" visible={visibleConfirm}
                    onHide={this.hideConfirm} actions={confirmActions} title="Atenção" >
                    <p>Deseja realmente excluir esse registro?</p>
                </DialogContainer>
                
                <Message />
            </Grid>
        );
    }

    getAll = () => {
        Api.getAllUsuarios()
        .then(response => response.json())
        .then(usuarios => this.setState({usuarios}))
        .catch(error => openSnackbar({ message: error }));
    }

    handleSearch = filter => {
        Api.getAllUsuarios(filter)
        .then(response => response.json())
        .then(usuarios => this.setState({usuarios}))
        .catch(error => openSnackbar({ message: error }));
    }

    handleChangeFilter = filter => {
        this.handleSearch(filter);
        this.setState({ filter });
    }

    handleChangeUsuario = value => {
        this.setState({ selectedUsuario: value });
    }

    handleUsuarioClick = selectedUsuario => event => {
        this.setState({selectedUsuario});
        setTimeout(() => this.setState({selectedUsuario}), 100);
    }

    handleNewClick = event => {
        this.cleanSelectedUsuario();
        this.showForm(event);
    }

    handleEditCLick = event => {
        this.showForm(event);
    }

    handleDeleteCLick = () => {
        this.showConfirm();
    }

    deleteUsuario = () => {
        Api.deleteUsuario(this.state.selectedUsuario)
        .then(response => {
            if(response.status === 204)
                this.afterDeleteUsuario();
            else
                openSnackbar({ message: `Não foi possível excluir o usuario ${this.state.selectedUsuario.nome}` })
        })
        .catch(error => openSnackbar({ message: error }));
        this.hideConfirm();
    }

    hideForm = () => {
        this.setState({ visibleForm: false });
        this.cleanSelectedUsuario();
        this.getAll();
    }

    showForm = (e) => {
        let { pageX, pageY } = e;
        if (e.changedTouches) {
            pageX = e.changedTouches[0].pageX;
            pageY = e.changedTouches[0].pageY;
        }
        this.setState({ visibleForm: true, pageX, pageY });
    }

    showConfirm = () => {
        this.setState({ visibleConfirm: true });
      };
    
    hideConfirm = () => {
        this.setState({ visibleConfirm: false });
    };

    saveForm = usuario => {
        let selectedUsuario = new Usuario(usuario);
        selectedUsuario.beforeSave();
        Api.saveUsuario(selectedUsuario)
        .then(() => this.afterSaveForm())
        .catch(error => openSnackbar({ message: error }));
    }

    afterSaveForm = () => {
        openSnackbar({ message: 'Usuário salvo com sucesso' });
        this.hideForm();
        this.getAll();
    }

    afterDeleteUsuario = () => {
        this.cleanSelectedUsuario();
        this.getAll();
        openSnackbar({ message: 'Usuário Excluído com sucesso' });
    }

    cleanSelectedUsuario = () => {
        const selectedUsuario = new Usuario();
        this.setState({selectedUsuario});
    }

    renderSelectedClass = (usuario) => {
        return usuario.id === this.state.selectedUsuario.id ? "item-selected" : "";
    };

    hasSelected = () => this.state.selectedUsuario.id ? false : true;

}



// WEBPACK FOOTER //
// ./src/views/usuarios/Usuarios.js